<button color="green"
        class="download-evaluation"
        (click)="onDownloadEvaluation()"
        [loading]="downloadInProgress"
        [disabled]="downloadInProgress"
        type="button">
    <app-icon name="download" />
    <ng-container i18n="@@evaluationDownloadButton">
        Auswertung herunterladen
    </ng-container>
</button>
